import { createApp } from 'vue';

import ProjectCheckoutButton from 'components/project/ProjectCheckoutButton.vue';
import { i18n } from 'locales';

const app = createApp();
app.component(ProjectCheckoutButton.name, ProjectCheckoutButton);
app.use(i18n);
app.mount('#vue-project-checkout-button');
